import { createAsyncThunk } from '@reduxjs/toolkit';
import * as topiocsApi from '../../../api/hotTopicsApi';

export const getAllTopics = createAsyncThunk('getAllTopics', async (data) => {
	const res = await topiocsApi.getAllTopics(data);
	return res.data;
});